import ReadyIcon from "../components/ReadyIcon";
import FinishedIcon from "../components/FinishedIcon";
import { P2 } from "../../../components/Paragraph";
import { MathJax } from "better-react-mathjax";
import styles from "./historyLine.module.css";

const HistoryLine = ({ topic, status, ...rest }) => {
  let icon = <div className={styles.historyIcon} />;
  if (status?.toLowerCase() === "ready")
    icon = (
      <div className={styles.historyIcon}>
        <ReadyIcon />
      </div>
    );
  if (status?.toLowerCase() === "finished")
    icon = (
      <div className={styles.historyIcon}>
        <FinishedIcon />
      </div>
    );

  return (
    <div className={styles.historyLine}>
      {icon}
      <P2>
        <MathJax inline dynamic>
          {topic}
        </MathJax>
      </P2>
    </div>
  );
};

export default HistoryLine;
